import React, {Component} from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

import {
  withStyles,
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
} from '@material-ui/core';

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 300,
    height: 58
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
});

class SelectDropdown extends Component {
  state = {
    labelWidth: 0
  };
  createOptions = (options) => {
    let ops = options.map(options => (
        <MenuItem key={options.id} value={options.id}>
            {options.name}
        </MenuItem>
    ));
    this.setState({
        labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth,
        options: ops
    });
  }

  componentDidMount() {
    const { options } = this.props;
   
    this.createOptions(options);
  }

  render() {
    const { classes, error, required, label, onChange, value, name, hint, disabled } = this.props;

    return (
      <FormControl error={error} variant="outlined" className={classes.formControl} required={required}>
        <InputLabel
          htmlFor="outlined-age-simple"
          ref={ref => {
            this.InputLabelRef = ref;
          }}
        >
          {label}
        </InputLabel>
        <Select
          disabled={disabled}
          value={value}
          name={name}
          onChange={onChange}
          input={
            <OutlinedInput
              labelWidth={this.state.labelWidth}
              name="age"
              id="outlined-age-simple"
            />
          }
        >
          {this.state.options}
        </Select>
        <FormHelperText>{hint}</FormHelperText>
      </FormControl>
    );
  }
}

SelectDropdown.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  hint: PropTypes.string,
  error: PropTypes.bool
};

export default withStyles(styles)(SelectDropdown);
